import React from 'react';
import ActaManagement from '../features/actas/ActaManagement';

const ActaManagementPage = () => {
  return <ActaManagement />;
};

export default ActaManagementPage;